import { OrganizationFull, TwinConversationType, TwinMessageContextType, TwinMessageSearchType } from 'api/model'
import { useState } from 'react'

export type RelevanceConfig = {
  contextType?: TwinMessageContextType
  searchType?: TwinMessageSearchType
  contextSize?: number
  maxContextSize?: number
  relevance?: number
  temperature?: number
  maxTemperature?: number
  modelType?: string
  summaryModelType?: string
  distance?: number
  combineSearch?: boolean
  mapReduceDepth?: number
}

export function getDebugProperties(isSystemAdmin: boolean, properties: RelevanceConfig) {
  const {
    contextSize,
    maxContextSize,
    relevance,
    searchType,
    contextType,
    temperature,
    maxTemperature,
    modelType,
    summaryModelType,
    distance,
    combineSearch,
    mapReduceDepth,
  } = properties

  if (!isSystemAdmin) {
    return {
      context_size: undefined,
      max_context_size: undefined,
      relevance_stddiv_threshold: undefined,
      search_type: undefined,
      context_type: undefined,
      temperature: undefined,
      max_temperature: undefined,
      model: undefined,
      summaryModelType: undefined,
      distance: undefined,
      combine_search: undefined,
      map_reduce_depth: undefined,
    }
  }
  return {
    context_size: contextSize,
    max_context_size: maxContextSize,
    relevance_stddiv_threshold: relevance,
    search_type: searchType,
    context_type: contextType,
    temperature: temperature,
    max_temperature: maxTemperature,
    model: modelType,
    summary_model: summaryModelType,
    distance,
    combine_search: combineSearch,
    map_reduce_depth: mapReduceDepth,
  }
}

function useFetchDebugSettings(organization: OrganizationFull | null) {
  const [isVerboseLogModalOpen, setIsVerboseLogModalOpen] = useState<boolean>(false)
  const [contextType, setContextType] = useState<TwinMessageContextType>(TwinMessageContextType.stuff)
  const [searchType, setSearchType] = useState<TwinMessageSearchType>(TwinMessageSearchType.similarity)
  const [contextSize, setContextSize] = useState<string>('4')
  const [maxContextSize, setMaxContextSize] = useState<string>('16')
  const [relevance, setRelevance] = useState<number>(2)
  const [temperature, setTemperature] = useState<number>(0.1)
  const [maxTemperature, setMaxTemperature] = useState<number>(0.5)
  const [modelType, setModelType] = useState<string>(organization?.base_model ?? 'gpt-4o')
  const [summaryModelType, setSummaryModelType] = useState<string>(organization?.summary_model ?? 'gpt-4o')
  const [distance, setDistance] = useState<number>(0.5)
  const [combineSearch, setCombineSearch] = useState<boolean>(true)
  const [mapReduceDepth, setMapReduceDepth] = useState<string>('2')
  const [conversationType, setConversationType] = useState<TwinConversationType>(TwinConversationType.chat)
  const [isStreamingToggled, setIsStreamingToggled] = useState<boolean>(true) // used to toggle streaming on/off
  const [isMobiusToggled, setIsMobiusToggled] = useState<boolean>(false) // used to toggle streaming on/off

  return {
    isVerboseLogModalOpen,
    setIsVerboseLogModalOpen,
    contextType,
    setContextType,
    searchType,
    setSearchType,
    contextSize,
    setContextSize,
    maxContextSize,
    setMaxContextSize,
    relevance,
    setRelevance,
    temperature,
    setTemperature,
    maxTemperature,
    setMaxTemperature,
    modelType,
    setModelType,
    summaryModelType,
    setSummaryModelType,
    distance,
    setDistance,
    combineSearch,
    setCombineSearch,
    mapReduceDepth,
    setMapReduceDepth,
    conversationType,
    setConversationType,
    isStreamingToggled,
    setIsStreamingToggled,
    isMobiusToggled,
    setIsMobiusToggled,
  }
}

export { useFetchDebugSettings }
